<template>
  <!--最外层包裹-->
  <div >
      dsadsadsada
  </div>
</template>
<script>
  import {getUserToken} from '@/config/config.js'
  import {getdetais} from '@/api/detais.js'
  export default {
    data() {
      return {

      }
    },
    mounted() {

    },
    methods: {


    }
  }
</script>




// WEBPACK FOOTER //
// src/pages/Recollection/index.vue